module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16rKx2M/tc-custom/9781631942730.jpg?1708805196371",
      "alt": "This image is the cover for the book Roderick Alleyn Mysteries Volume 3, Roderick Alleyn"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Roderick Alleyn Mysteries Volume 3, Roderick Alleyn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Three witty novels by")]), _vm._v(" "), _c('b', [_vm._v("“the finest writer in the English language of the pure, classical puzzle whodunnit” ("), _c('i', [_vm._v("The Sun")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This volume includes three books in the Golden Age detective series from the Mystery Writers of America Grand Master:"), _c('br'), _vm._v(" "), _c('br'), _c('b', [_c('i', [_vm._v("Death in a White Tie")])]), _vm._v(": A high-society homicide is the talk of the London season: “Marsh’s writing is a pleasure.” —"), _c('i', [_vm._v("The Seattle Times")]), _c('br'), _vm._v(" "), _c('br'), _c('b', [_c('i', [_vm._v("Overture to Death")])]), _c('i', [_vm._v(":")]), _vm._v(" In a Dorset village, a snobby local busybody is silenced for good in this tale by “a peerless practitioner of the slightly surreal, English-village comedy-mystery” ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(")."), _c('br'), _vm._v(" "), _c('br'), _c('b', [_c('i', [_vm._v("Death at the Bar")])]), _vm._v(": A famous barrister is enjoying a pint at the pub—until a dart becomes a deadly weapon . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “In her ironic and witty hands the mystery novel can be civilized literature.” —"), _c('i', [_vm._v("The New York Times")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ngaio Marsh\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0